import { type FC, type MouseEventHandler, type ReactNode } from "react";

import { Button } from "@snapchat/snap-design-system";

import { Flexbox, LabelWithTooltip } from "../../../../shared/components";
import { actionButton } from "../../../../shared/styles";

interface LensDetailsPanelProps {
    label: ReactNode;
    tooltipContent?: ReactNode;
    onButtonClick: MouseEventHandler<HTMLButtonElement>;
    buttonIcon: ReactNode;
    buttonLabel: string;
    isButtonDisabled?: boolean;
    detailsDisplayContent?: ReactNode;
    showDetailsDisplayContent?: boolean;
    dataTestId?: string;
}

export const LensDetailsPanel: FC<LensDetailsPanelProps> = ({
    label,
    tooltipContent,
    onButtonClick,
    buttonIcon,
    buttonLabel,
    isButtonDisabled,
    detailsDisplayContent,
    showDetailsDisplayContent,
    dataTestId,
}) => {
    return (
        <Flexbox alignItems="center" justifyContent="space-between" data-testid={dataTestId}>
            <Flexbox justifyContent="flex-start" alignItems="flex-start" flexDirection="column">
                <LabelWithTooltip label={label} content={tooltipContent} />
                {showDetailsDisplayContent && detailsDisplayContent && (
                    <Flexbox flexDirection="row">{detailsDisplayContent}</Flexbox>
                )}
            </Flexbox>
            <Button size="small" className={actionButton} onClick={onButtonClick} isDisabled={isButtonDisabled}>
                {buttonIcon}
                {buttonLabel}
            </Button>
        </Flexbox>
    );
};
